/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, Input } from '@angular/core';
import { Field } from '@src/app/shared/field/Field';
import { AbstractObject } from '@src/app/model/abstract-object';
import { MatIconModule } from '@angular/material/icon';
import { IconTableCellComponent } from "@src/app/shared/table/icon-table-cell/icon-table-cell.component";
import { LinkTableCellComponent } from "@src/app/shared/table/link-table-cell/link-table-cell.component";
import { PicklistTableCellComponent } from "@src/app/shared/table/picklist-table-cell/picklist-table-cell.component";
import { DateTimeTableCellComponent } from "@src/app/shared/table/date-time-table-cell/date-time-table-cell.component";
import { LimitToPipe } from '@src/app/shared/pipes/limit-to.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PickLinkTableCellComponent } from "@src/app/shared/table/pick-link-table-cell/pick-link-table-cell.component";
import { FormPillComponent, PillField } from "@src/app/shared/form/form-pill/form-pill.component";

@Component({
    selector: 'app-table-cell',
    templateUrl: './table-cell.component.html',
    styleUrl: './table-cell.component.scss',
    imports: [MatIconModule, LimitToPipe,
        IconTableCellComponent, LinkTableCellComponent, PicklistTableCellComponent,
        DateTimeTableCellComponent, MatTooltipModule,
        PickLinkTableCellComponent, FormPillComponent]
})
export class TableCellComponent {
    @Input({required: true}) field: Field;
    @Input({required: true}) focusItem: AbstractObject;

    /** 'pill' cell click - run the field's tableClick flow and drop the refreshed row back in place. */
    pillClicked(field: PillField, focusItem: AbstractObject) {
        field.tableClick?.(focusItem).subscribe(updated => {
            if (updated) { Object.assign(focusItem, updated); }
        });
    }
}
